import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'itpx-table-create',
    templateUrl: './table-create.component.html',
    styleUrls: ['./table-create.component.css']
})
export class TableCreateComponent {

    private readonly DIMENSION_SIZE = 5;
    readonly tableRange = new Array(this.DIMENSION_SIZE * this.DIMENSION_SIZE)
        .fill(0, 0, this.DIMENSION_SIZE * this.DIMENSION_SIZE)
        .map((x, i) => i);

    hoverState = {row: -1, col: -1};

    @Output() onTableSelection = new EventEmitter();

    constructor() {
    }

    onHover(index: number) {
        this.hoverState = this.indexToTableCoords(index);
    }

    inRange(index: number): boolean {
        const {row: hoveredRow, col: hoveredCol} = this.hoverState;
        const {row, col} = this.indexToTableCoords(index);

        return row <= hoveredRow && col <= hoveredCol;
    }

    onTablePreviewClick(event: MouseEvent) {
        this.onTableSelection.emit({event, state: this.hoverState});
    }

    private indexToTableCoords(index: number) {
        return {
            row: Math.floor(index / this.DIMENSION_SIZE),
            col: index % this.DIMENSION_SIZE
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/silk/toolbars/standard-toolbar/table-create/table-create.component.ts